import { useTranslation } from 'react-i18next';

import { FieldWithLabel, DebouncedInput } from '@app/shared/ui/atoms/Common';
import { RadioGroup } from '@app/shared/ui/molecules/Admin/Common';
import { FIND_USER_OPTIONS, FIND_USER_PLACEHOLDERS_MAP } from '@app/shared/constants/admin/common';
import { FindUserBy } from '@app/shared/types/admin/common';

interface FindUserSectionProps {
  findUserBy: FindUserBy;
  onFindUserByChange: (value: FindUserBy) => void;
  findUserValue: string;
  onFindUserValueChange: (value: string) => void;
}

export function FindUserSection({
  findUserBy,
  onFindUserByChange,
  findUserValue,
  onFindUserValueChange,
}: FindUserSectionProps) {
  const { t } = useTranslation();

  const findUserOptions = FIND_USER_OPTIONS.map((item) => ({
    value: item.value,
    label: t(`admin_common.${item.translationKey}`),
  }));

  return (
    <FieldWithLabel label={t('admin_common.find_user')}>
      <RadioGroup items={findUserOptions} value={findUserBy} onValueChange={onFindUserByChange} />
      <DebouncedInput
        value={findUserValue}
        onChange={onFindUserValueChange}
        placeholder={`${t('admin_common.enter')} ${t(`admin_common.${FIND_USER_PLACEHOLDERS_MAP[findUserBy]}`)}`}
      />
    </FieldWithLabel>
  );
}
